module.exports = __webpack_public_path__ + "img/logo.e1f665b3.png";